"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ProgressiveSec_exports = {};
__export(ProgressiveSec_exports, {
  default: () => ProgressiveSec_default
});
module.exports = __toCommonJS(ProgressiveSec_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 10H25.5V18.8426C25.5 19.5987 25.7143 20.3393 26.118 20.9786L33.6247 32.864C35.3068 35.5275 33.3929 39 30.2427 39H9.7573C6.60708 39 4.69316 35.5275 6.37535 32.864L13.882 20.9786C14.2857 20.3393 14.5 19.5987 14.5 18.8426V10Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.7588 32.0799L10.1 27.6249H30.5188L33.86 32.0799C36.3075 35.3431 33.9791 39.9999 29.9 39.9999H10.7188C6.63977 39.9999 4.31138 35.3431 6.7588 32.0799Z",
      fill: "#E4844F"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.1126 31.188C16.181 31.789 15.7492 32.3316 15.1482 32.3999C14.5472 32.4683 14.0046 32.0365 13.9363 31.4355C13.8679 30.8345 14.2997 30.2919 14.9007 30.2236C15.5017 30.1553 16.0443 30.587 16.1126 31.188Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.0126 32.4255C26.081 33.0265 25.6492 33.5691 25.0482 33.6374C24.4472 33.7058 23.9046 33.274 23.8363 32.673C23.7679 32.072 24.1997 31.5294 24.8007 31.4611C25.4017 31.3928 25.9443 31.8245 26.0126 32.4255Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.4439 35.2718C20.5122 35.8728 20.0804 36.4154 19.4795 36.4838C18.8785 36.5521 18.3359 36.1203 18.2675 35.5193C18.1992 34.9183 18.631 34.3758 19.232 34.3074C19.833 34.2391 20.3755 34.6709 20.4439 35.2718Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.3483 20.7685V10.5474H27.4251C27.8351 10.5474 28.1676 10.215 28.1676 9.8049C28.1676 9.39483 27.8351 9.0624 27.4251 9.0624H12.5751C12.165 9.0624 11.8326 9.39483 11.8326 9.8049C11.8326 10.215 12.165 10.5474 12.5751 10.5474H13.6517V20.7685L5.64684 32.2128C3.35196 35.4937 5.6992 40 9.70306 40H30.2969C34.3008 40 36.648 35.4937 34.3531 32.2128L26.3483 20.7685ZM10.1488 28.3673L6.8637 33.0639C5.25729 35.3606 6.90036 38.515 9.70306 38.515H30.2969C33.0996 38.515 34.7427 35.3606 33.1363 33.0639L29.8514 28.3677L10.1488 28.3673ZM11.1875 26.8823L28.8127 26.8826L24.8633 21.2364V10.5474H15.1367V13.3937H17.5003C17.842 13.3937 18.119 13.6707 18.119 14.0124C18.119 14.3541 17.842 14.6312 17.5003 14.6312H15.1367V17.0442H17.5003C17.842 17.0442 18.119 17.3212 18.119 17.663C18.119 18.0047 17.842 18.2817 17.5003 18.2817H15.1367V21.2364L11.1875 26.8823Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.505 2.8749C19.505 3.90008 18.6739 4.73115 17.6488 4.73115C16.6236 4.73115 15.7925 3.90008 15.7925 2.8749C15.7925 1.84972 16.6236 1.01865 17.6488 1.01865C18.6739 1.01865 19.505 1.84972 19.505 2.8749Z",
      fill: "#E4844F"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.6488 1.6374C16.9653 1.6374 16.4113 2.19145 16.4113 2.8749C16.4113 3.55835 16.9653 4.1124 17.6488 4.1124C18.3322 4.1124 18.8863 3.55835 18.8863 2.8749C18.8863 2.19145 18.3322 1.6374 17.6488 1.6374ZM15.1738 2.8749C15.1738 1.508 16.2819 0.399902 17.6488 0.399902C19.0157 0.399902 20.1238 1.508 20.1238 2.8749C20.1238 4.24181 19.0157 5.3499 17.6488 5.3499C16.2819 5.3499 15.1738 4.24181 15.1738 2.8749Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M24.1085 5.17678C24.1085 5.86024 23.5544 6.41429 22.871 6.41429C22.1875 6.41429 21.6335 5.86024 21.6335 5.17678C21.6335 4.49333 22.1875 3.93929 22.871 3.93929C23.5544 3.93929 24.1085 4.49333 24.1085 5.17678Z",
      fill: "#E4844F"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.871 4.55803C22.5293 4.55803 22.2522 4.83506 22.2522 5.17678C22.2522 5.51851 22.5293 5.79554 22.871 5.79554C23.2127 5.79554 23.4897 5.51851 23.4897 5.17678C23.4897 4.83506 23.2127 4.55803 22.871 4.55803ZM21.0147 5.17678C21.0147 4.15161 21.8458 3.32054 22.871 3.32054C23.8962 3.32054 24.7272 4.15161 24.7272 5.17678C24.7272 6.20196 23.8962 7.03303 22.871 7.03303C21.8458 7.03303 21.0147 6.20196 21.0147 5.17678Z",
      fill: "currentColor"
    }
  )
);
const SvgProgressiveSec = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ProgressiveSec_default = SvgProgressiveSec;
